export default {
  /**
   * @desc 话题页面数据
   */
  state: {
    points: [{
      times: '609期',
      title: '提高个税起征点真能减负嘛？',
      msg: '3月7日，财政部部长肖捷在发布会上表示，个人所得税免征额将根据消费水平综合测算，...'
    }, {
      times: '609期',
      title: '提高个税起征点真能减负嘛？',
      msg: '3月7日，财政部部长肖捷在发布会上表示，个人所得税免征额将根据消费水平综合测算，...'
    }, {
      times: '609期',
      title: '提高个税起征点真能减负嘛？',
      msg: '3月7日，财政部部长肖捷在发布会上表示，个人所得税免征额将根据消费水平综合测算，...'
    }]
  }
}



// WEBPACK FOOTER //
// ./src/store/PointStore.js